export default "__VITE_ASSET__C0llhM2y__"